import { render, staticRenderFns } from "./PutAwayBackground.vue?vue&type=template&id=40c5ae04&"
import script from "./PutAwayBackground.vue?vue&type=script&lang=js&"
export * from "./PutAwayBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports